import { Tag } from 'antd';
import { ICellRendererProps } from 'common/components/table/table.types';
import { visitorBanEntryTypeColorMap, visitorBanEntryTypeMap } from 'common/constans/visitor-ban-entry.constants';
import { VisitorBanEntryType } from 'common/enums/visitor-ban-entry-type.enum';
import { IVisitorBanListEntry } from 'common/services/visitor-ban-list-service/visitor-ban-list.service.types.';

export const visitorBanListInitialColumns = [
  {
    key: 'firstName',
    title: 'First Name',
    dataKey: 'firstName',
    width: 240,
    fixed: 1,
    resizable: true,
    sortable: true,
  },
  {
    key: 'lastName',
    title: 'Last Name',
    dataKey: 'lastName',
    width: 240,
    fixed: 1,
    resizable: true,
    sortable: true,
  },
  {
    key: 'companyName',
    title: 'Company Name',
    dataKey: 'companyName',
    width: 240,
    fixed: 1,
    resizable: true,
    sortable: true,
  },
  {
    key: 'licensePlate',
    title: 'License Plate',
    dataKey: 'licensePlate',
    width: 240,
    fixed: 1,
    resizable: true,
    sortable: true,
  },
  {
    key: 'type',
    title: 'Type',
    dataKey: 'type',
    width: 120,
    fixed: 1,
    resizable: true,
    sortable: true,
    cellRenderer: (cell: ICellRendererProps<IVisitorBanListEntry>) => {
      const type = cell.cellData as VisitorBanEntryType;
      return (
        <Tag className="eiq-tag" color={visitorBanEntryTypeColorMap[type]} style={{ color: '#292B2E' }}>
          {visitorBanEntryTypeMap[type]}
        </Tag>
      );
    },
  },
  {
    key: 'action',
    title: 'Action',
    dataKey: 'action',
    width: 180,
    fixed: 1,
    resizable: true,
    sortable: false,
  },
  {
    key: 'reason',
    title: 'Reason',
    dataKey: 'reason',
    width: 300,
    fixed: 1,
    resizable: true,
    sortable: false,
  },
];
